import { GetFacturaProformaByIdDtoProps } from "./DTOs/GetFacturaProformaByIdDto"
import { GetFacturaProformaDetalleByIdDtoProps } from "./DTOs/GetFacturaProformaDetalleByIdDto"
import { GetFacturasProformaByFiltersDtoProps } from "./DTOs/GetFacturasProformaByFiltersDto"

export const getFacturaProformaAdapter = (
  factura: GetFacturasProformaByFiltersDtoProps
): GetFacturasProformaByFiltersDtoProps => ({
  id: factura.id,
  cliente: factura.cliente,
  factura: factura.factura,
  fechaEmision: factura.fechaEmision,
  importe: factura.importe,
  numero: factura.numero,
})

export const getFacturaProformaByIdAdapter = (
  factura: GetFacturaProformaByIdDtoProps
): GetFacturaProformaByIdDtoProps => ({
  ficheroId: factura.ficheroId,
  razonSocial: factura.razonSocial,
  fechaEmision: factura.fechaEmision,
  importe: factura.importe,
  numero: factura.numero,
})

export const getFacturaProformaDetalleByIdAdapter = (
  factura: GetFacturaProformaDetalleByIdDtoProps
): GetFacturaProformaDetalleByIdDtoProps => ({
  cliente: factura.cliente,
  conceptos: factura.conceptos,
  descuento: factura.descuento,
  divisa: factura.divisa,
  fechaEmision: factura.fechaEmision,
  fechaVencimiento: factura.fechaVencimiento,
  ficheroId: factura.ficheroId,
  importe: factura.importe,
  importeBruto: factura.importeBruto,
  importeDescuento: factura.importeDescuento,
  numero: factura.numero,
  numeroDocumento: factura.numeroDocumento,
  proveedor: factura.proveedor,
  razonSocial: factura.razonSocial,
  retencion: factura.retencion,
})
